import createPersistedState from 'use-persisted-state';
import { VIEW_ADDRESS_STORAGE_KEY } from './constants';

const useViewAddressState = createPersistedState<string[]>(
  VIEW_ADDRESS_STORAGE_KEY
);

export const useViewAddressStorage = () => {
  const [addressBookStorageState, setAddressBookStorageState] =
    useViewAddressState([]);

  const addAddress = (address: string) => {
    setAddressBookStorageState((state) =>
      state.includes(address) ? state : [...state, address]
    );
  };

  const removeAddress = (address: string) => {
    setAddressBookStorageState((state) => state.filter((a) => a !== address));
  };

  return {
    addressList: addressBookStorageState,
    addAddress: addAddress,
    removeAddress: removeAddress,
  };
};
